module.exports = __webpack_public_path__ + "static/media/img1-1.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/nutricheck_foliar/ZN/img1-1.png
// module id = 2267
// module chunks = 3